import { Switch } from "@/components/ui/switch";
import { useToggleSupplierMutation } from "@/services/supplier";
import { toast } from "components/ui/use-toast";

interface ToggleStatusSwitchProps {
  id: number;
  isActive: boolean;
}

export const ToggleStatusSwitch: React.FC<ToggleStatusSwitchProps> = ({
  id,
  isActive,
}) => {
  const [toggleNcm, { isLoading }] = useToggleSupplierMutation();

  const handleToggleStatus = async () => {
    try {
      await toggleNcm(id).unwrap();
      toast({
        title: "Sucesso",
        description: `Item ${isActive ? "inativado" : "ativado"} com sucesso!`,
        variant: "success",
      });
    } catch (error) {
      console.error("Erro ao alterar status do item", error);
      toast({
        title: "Erro ao alterar status do item.",
        variant: "destructive",
      });
    }
  };

  return (
    <Switch
      checked={isActive}
      onCheckedChange={handleToggleStatus}
      disabled={isLoading}
    />
  );
};
